<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="$t('养车无忧.标题')" prop="title" >
        <a-input v-model="form.title" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('养车无忧.标题')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('养车无忧.描述')" prop="description" >
        <a-textarea v-model="form.description" :rows="3" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('养车无忧.描述')" />
      </a-form-model-item>

      <a-form-model-item :label="$t('养车无忧.列表图片')" prop="listImage" >
        <OssUploadSingle v-model="form.listImage" type="img" :maxSize="200" />
      </a-form-model-item>

      <a-form-model-item :label="$t('养车无忧.排序')" prop="orderSort" >
        <a-input-number style="width: 100%" v-model="form.orderSort" :min="0" @change="limitSort" :placeholder="$t('通用.输入.请输入')+$t('养车无忧.排序')" />
      </a-form-model-item>

<!--      <a-form-model-item :label="$t('养车无忧.状态')" prop="status" >-->
<!--        <a-radio-group v-model="form.status"  button-style="solid">-->
<!--          <a-radio-button v-for="(item, index) in this.customDict.CarCarefreeStatusEnum" :value="item.type" :key="index">-->
<!--            {{ item.name }}-->
<!--          </a-radio-button>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->

      <a-form-model-item :label="$t('养车无忧.详情')" prop="contentInfo" >
        <editor v-model="form.contentInfo" :height="300" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getCarCarefree, addCarCarefree, updateCarCarefree} from '@/api/carcarefree/carcarefree'
import {mapGetters} from 'vuex'
import OssUploadSingle from "@/components/OssUploadSingle"
import Editor from "@/components/Editor/Editor"

export default {
  name: 'CreateForm',
  components: {
    OssUploadSingle,
    Editor
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        title: null,
        description: null,
        listImage: null,
        contentInfo: null,
        orderSort: 0,
        status: 1,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        title: [
          { required: true, message: this.$t('养车无忧.标题')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        contentInfo: [
          { required: true, message: this.$t('养车无忧.详情')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        description: null,
        listImage: null,
        contentInfo: null,
        orderSort: 0,
        status: 1,
        remark: null
      }
    },
    limitSort(sort) {
      let val = sort;
      if(val==null||val==undefined||val==''|| val<0){
        val=0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.orderSort = val
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加');
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCarCarefree({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCarCarefree(this.form).then(response => {
              this.$message.success(this.$t('通用.文本.修改成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCarCarefree(this.form).then(response => {
              this.$message.success(this.$t('通用.文本.新增成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .adaptive { height: auto; }
::v-deep .editor .w-e-text-container { height: 300px !important; }
</style>
